"use client";

import React from "react";
import { Building2, Briefcase, Network, ArrowRight, Plus } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const eligibilityItems = [{
  icon: Building2,
  engine: "ENGINE 01",
  title: "Real Estate Investors",
  desc: "Seeking first mortgage debt or gap equity for Fix-and-Flip, BRRRR, Buy-and-Hold, or New Construction deals."
}, {
  icon: Briefcase,
  engine: "ENGINE 02",
  title: "Joint Venture Partners",
  desc: "Individuals with a credit score above 700, available capital, or verifiable real estate investing experience."
}, {
  icon: Network,
  engine: "ENGINE 03",
  title: "Referral Network",
  desc: "Brokers, realtors, capital partners, developers, and contractors looking to refer investors and earn commissions."
}];
export default function PreQualification() {
  const {
    ref: leftRef,
    isVisible: leftVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: rightRef,
    isVisible: rightVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="pre-qualification-overview" className="bg-background text-foreground py-24 px-6 relative overflow-hidden border-y border-border/30">
      {}
      <div className="absolute inset-0 pointer-events-none opacity-[0.03]" style={{
      backgroundImage: 'radial-gradient(circle at 2px 2px, currentColor 1px, transparent 0)',
      backgroundSize: '32px 32px'
    }} />

      <div className="max-w-[1400px] mx-auto relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center">
          
          {}
          <div ref={leftRef} className={`lg:col-span-5 flex flex-col justify-center transition-all duration-1000 ease-out ${leftVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            <div className="mb-6 relative inline-block self-start">
              <span className="font-mono text-primary tracking-widest uppercase text-sm font-medium">
                01 // Pre-Qualification
              </span>
              {}
              <div className="absolute -left-6 top-1/2 w-4 h-[1px] bg-primary/50" />
            </div>
            
            <h2 className="font-default text-3xl md:text-4xl lg:text-5xl font-bold mb-6 leading-tight tracking-tight">
              Determine Your <br className="hidden lg:block" />
              <span className="text-muted-foreground">Funding Eligibility.</span>
            </h2>
            
            <p className="text-muted-foreground text-lg mb-8 leading-relaxed max-w-xl">
              Before we architect your capital stack, we need to assess the foundation. Our pre-qualification process is direct, transparent, and designed to quickly identify which of our three funding engines aligns with your current position.
            </p>
            
            <div>
              <Button asChild size="lg" className="bg-primary text-primary-foreground hover:bg-primary/90 uppercase font-bold tracking-wide shadow-md group">
                <Link to="/PreQualificationFormPage">
                  Start Pre-Qualification
                  <ArrowRight className="ml-2 size-4 transition-transform group-hover:translate-x-1" />
                </Link>
              </Button>
            </div>
          </div>

          {}
          <div ref={rightRef} className="lg:col-span-7 flex flex-col gap-6 relative">
            {}
            <div className="hidden lg:block absolute -left-8 top-0 bottom-0 w-[1px] bg-border/30" />

            {eligibilityItems.map((item, i) => <Card key={i} data-index={i} className={`bg-card border-border/40 shadow-sm relative overflow-hidden group transition-all duration-700 ease-out hover:border-primary/30 ${rightVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-8"}`} style={{
            transitionDelay: `${i * 150}ms`
          }}>
                {}
                <Plus className="absolute top-2 left-2 size-3 text-primary/30 opacity-0 group-hover:opacity-100 transition-opacity" />
                <Plus className="absolute bottom-2 right-2 size-3 text-primary/30 opacity-0 group-hover:opacity-100 transition-opacity" />

                <CardHeader className="pb-2 flex flex-row items-start sm:items-center gap-4 space-y-0">
                  <div className="shrink-0 p-3 bg-background border border-border/50 shadow-xs">
                    <item.icon className="size-6 text-primary" />
                  </div>
                  <div>
                    <span className="font-mono text-xs text-muted-foreground tracking-widest uppercase block mb-1">
                      {item.engine}
                    </span>
                    <CardTitle className="font-default text-xl text-card-foreground">
                      {item.title}
                    </CardTitle>
                  </div>
                </CardHeader>
                <CardContent className="pt-2 sm:pl-[4.5rem]">
                  <p className="text-muted-foreground leading-relaxed">
                    {item.desc}
                  </p>
                </CardContent>
              </Card>)}
          </div>

        </div>
      </div>
    </section>;
}